<script setup>
import { defineProps, computed, defineEmits } from 'vue'

const props = defineProps({
    id: {
        type: Number,
        required: true
    },
    full_name: {
        type: String,
        required: true
    },
    job_title: {
        type: String,
        required: true
    },
    job_title_of_main_workplace: {
        type: String,
        required: true
    },
    profile_pic: {
        type: String,
        required: true
    },
    is_hidden_info: {
        type: Boolean,
        required: true
    }
})
const emit = defineEmits(['clickCard'])

function clickCard(){
    emit('clickCard', props.id)
}

let _profile_pic = computed(() => {
    if (props.profile_pic)
        return document.location.origin + '/' + props.profile_pic
    return '/img/empty_avatar.png'})



</script>

<template>
    <div 
        v-if="!props.is_hidden_info"
        class="personality-card"
        @click="clickCard">
        <img 
            width="190"
            height="195"
            :src="_profile_pic"
            alt="/img/empty_avatar.png"
        >
        <div class="personality-card-text">
            <div class="personality-card-text-title">
                <h3>
                    {{ props.full_name }}
                </h3>
                <h4>
                    {{ props.job_title }}
                </h4>
            </div>
            <p>
                {{ props.job_title_of_main_workplace }}
            </p> 
        </div>
    </div>
    <div 
        v-else 
        class="personality-card not-clickable"
    >
        <img 
            width="190"
            height="195"
            :src="_profile_pic"
            alt="/img/empty_avatar.png"
        >
        <div class="personality-card-text">
            <div class="personality-card-text-title">
                <h3>
                    {{ props.full_name }}
                </h3>
                <h4>
                    {{ props.job_title }}
                </h4>
            </div>
            <p>
                {{ props.job_title_of_main_workplace }}
            </p> 
        </div>
    </div>
</template>

<style lang="scss" scoped>
.personality-card {
    display: flex;
    align-items: start;
    gap: 30px;
    padding-bottom: 15px;
    border-bottom: #eff0f2 1px solid;

    @media screen and (max-width: 600px) {
        flex-direction: column;
        align-items: center;
    }
}

.personality-card-text {
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: left;

    @media screen and (max-width: 600px) {
        align-items: center;
        text-align: center;
    }
}

.personality-card-text-title {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-weight: 500;

    h3 {
        font-size: 20px;
        line-height: 28px;
        color: #002866;
    }

    h4 {
        font-size: 17px;
        color: #0635ac;
    }

    @media screen and (max-width: 600px) {
        align-items: center;
        text-align: center;
    }
}

.not-clickable {
  cursor: default !important;
}
</style>
